import { useState, useEffect, useRef } from 'react'
import Healthalertpanel from "./healthalertpanel.js"
import Healthmonitoringdetail from "./healthmonitoringdetail.js"
import styles from './css/healthmonitoring.module.css'
import Healthmonitoringgraphs from "./healthmonitoringgraphs.js"
import invoke from "../calllambda"
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { DataGrid, gridPageCountSelector, GridPagination, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';
import { seisleveljp } from "./seislevel"

//datagridのページネーション
function Pagination({
    page,
    onPageChange,
    className,
  }) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  
    return (
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event, newPage - 1);
        }}
        sx={{overflow: "hidden"}}
      />
    );
  }
  
  function CustomPagination(props) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
  }


export default function Healthmonitoring(props) {
    const [listreload, setlistreload] = useState(new Date());
    const [calculating, setcalculating] = useState(false);
    const [event, setEvent] = useState(null);
    const [kanrimode, setKanrimode] = useState(true);
    const [listshow, setListshow] = useState("none");
    const [eventlist, setEventList] = useState([]);
    const [listrows, setListrows] = useState([]);
    const [mapimage, setMapimage] = useState("data:image/png");
    const ref = useRef();

    useEffect(() => {
        if (props.point && props.point.sensors && props.point.sensors.earthquake && props.point.sensors.earthquake.length > 0) {
            var sensor_id = props.point.sensors.earthquake[0].id;
            var args = {};
            if (props.datetime && props.datetime != "") {
                args = { sensor_id: sensor_id, datetime: props.datetime };
            } else {
                args = { sensor_id: sensor_id };
            }
            invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:eventlist", args).then(function (value) {
                if (value !== undefined && value.length > 0) {
                    setEvent(value[0]);
                    setEventList(value);
                    var rows = [];
                    value.forEach((avalue, index) => {
                        var values = avalue.estimate == undefined ? avalue.values : avalue.estimate;
                        rows.push( {
                            id: index+1,
                            datetime: avalue.datetime,
                            seis: avalue.values[0].seis,
                            seislevel: avalue.values[0].seis,
                            acc: avalue.values[0].max_gal_cmp,
                            accx: avalue.values[0].max_gal_x,
                            accy: avalue.values[0].max_gal_y,
                            accz: avalue.values[0].max_gal_z,
                            dspx: avalue.values[0].max_cm_x,
                            dspy: avalue.values[0].max_cm_y,
                            dspz: avalue.values[0].max_cm_z,
                        } );
                    });
                    setListrows(rows);
                } else {
                    setEvent({});
                }
            });
            args = { site_id: props.point.id };
            invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:drawingimage", args).then(function (value) {
                if (value !== undefined && value.length > 0) {
                    setMapimage("data:image/png;base64," + value);
                } else {
                    setMapimage("");
                }
            });
        } else {
            setEvent([]);
            setEventList([]);
        }
    }, [listreload]);
     
    const columns = [
      { field: 'datetime', headerName: '発生日時', width: 200, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return japanesedate(new Date(value))} },
      { field: 'seislevel', headerName: '震度階級', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return  seisleveljp(value)} },
      { field: 'seis', headerName: '計測震度', width: 148, headerAlign: 'center', align: 'center' },
      { field: 'acc', headerName: '最大加速度合成[gal]', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return Math.round(value*100)/100} },
      { field: 'accx', headerName: '最大加速度X[gal]', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return Math.round(value*100)/100} },
      { field: 'accy', headerName: '最大加速度Y[gal]', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return Math.round(value*100)/100} },
      { field: 'accz', headerName: '最大加速度Z[gal]', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return Math.round(value*100)/100} },
      { field: 'dspx', headerName: '最大変位X[cm]', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return Math.round(value*100)/100} },
      { field: 'dspy', headerName: '最大変位Y[cm]', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return Math.round(value*100)/100} },
      { field: 'dspz', headerName: '最大変位Z[cm]', width: 148, headerAlign: 'center', align: 'center', valueFormatter: ( value ) => {return Math.round(value*100)/100} },
    ];

    const cellClickHandler = event => {
      setEvent(eventlist[event.row.id - 1]);
    }

    function japanesedate(date) {
        return date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日"
            + date.getHours() + "時" + date.getMinutes() + "分";
    }

    const handleRecalculate = async () => {
        setcalculating(true)
        try {
            await invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:downloadeventwin", { sensor_id: event.sensor_id, datetime: event.datetime, update: true });
        } finally {
            setcalculating(false)
            setlistreload(new Date());
        }
    };

    return (
        <>
            {!event ? "データ読み込み中" : ! event.datetime ? "データがありません" : (
                <>
                    <div className={styles.header}>
                        <div className={styles.title}>
                            <span>{japanesedate(new Date(event.datetime)) + "の地震"}</span>
                            <span className={styles.calender} onClick={()=>{setListshow(listshow == "block" ? "none" : "block")}}><CalendarMonthIcon/></span>
                        </div>
                        <div className={styles.discription}>
                            <div>
                                <span className={styles.nowrap}><input type="radio" name="mode" id="kanri" onClick={() => { setKanrimode(true) }} defaultChecked={kanrimode}/><label htmlFor="kanri">管理者向け</label></span>
                                <span className={styles.nowrap}><input type="radio" name="mode" id="gijyutsu" onClick={() => { setKanrimode(false) }} defaultChecked={!kanrimode}/><label htmlFor="gijyutsu">技術者向け</label></span>
                            </div>
                            <div style={{ visibility: kanrimode ? "hidden" : "" }}><a href="#" onClick={() => {ref.current?.download()}}>Download</a></div>
                        </div>
                    </div>
                    <div style={{height:"454px", marginBottom: "32px", display:listshow}}>
                        <DataGrid rows={listrows} columns={columns} density="compact" autoPageSize={true} hideFooterSelectedRowCount pagination slots={{pagination: CustomPagination}} onCellClick={(event) => cellClickHandler(event)}/>
                    </div>
                    {!event.damage || !event.estimate ?
                        <div>データがありません
                            {props.admin > 0 &&  <button disabled={calculating} style={{display: "inline-block", padding: "2px 4px", fontSize: "12px", marginLeft: "8px", width: "auto" }} onClick={handleRecalculate}>{calculating ? "計算中" : "再計算"}</button>}
                        </div>
                    : (
                    <>
                    <div style={{display: kanrimode ? "" : "none" }}>
                        <Healthalertpanel event={event} />
                        <div className={styles.container}>
                            <div className={styles.iteml}>
                               <Healthmonitoringdetail event={event}/>
                            </div>
                            {mapimage != "" &&
                            <div className={styles.itemr}>
                                <img className={styles.mapimg} style={{maxHeight: 100*event.damage.length + "px"}} src={mapimage} alt="map"/>
                            </div>
                            }
                        </div>
                    </div>
                    <div style={{ display: kanrimode ? "none" : "" }}>
                        <Healthmonitoringgraphs height={160} event={event} visible={!kanrimode} ref={ref}/>
                    </div>
                    </>
                    )}
                </>
            )}
        </>
    )
}